import { TrackedEvents, trackEvent } from 'analytics';
import type { AluminiumAISampleComposition, PETComposition, QualityReportAISample } from 'api';
import { formatDate } from 'date';
import { useTranslation } from 'i18n';
import { useNavigate } from 'react-router-dom';
import { DataCard, ExpandableIconButton, Typography } from 'ui';
import { ImageOutlined, Insights } from 'ui/icons';

import { AiSampleBreakdown } from '../../../breakdowns';
import { AiLooseModels } from '../../../evidence';

export const AiLooseAnalysisDataCard = ({
  isLoading,
  composition,
  aiModel,
  hasMedia,
  sampleDate,
  totalWeight,
}: {
  isLoading?: boolean;
  composition?: AluminiumAISampleComposition | PETComposition;
  aiModel: AiLooseModels;
  hasMedia: boolean;
  sampleDate: QualityReportAISample['date'];
  totalWeight: QualityReportAISample['total_weight'];
}) => {
  const { t } = useTranslation('features');
  const navigate = useNavigate();

  const handleClickMedia = () => {
    trackEvent(TrackedEvents.QUALITY_REPORT_CLICK_CATEGORY_IMAGES, {
      category: 'AI Loose Analysis',
    });
    navigate('media?tab=ai_loose');
  };

  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          action: hasMedia ? (
            <ExpandableIconButton
              icon={<ImageOutlined />}
              label={t('dataCards.aiLooseAnalysis.showMediaLabel')}
              onClick={handleClickMedia}
            />
          ) : undefined,
          avatar: <Insights />,
          title: t('dataCards.aiLooseAnalysis.title'),
        },
      }}
    >
      <DataCard.Item colSpan={12}>
        <Typography
          variant="body1"
          color="secondary"
          sx={{
            paddingBottom: 2,
          }}
        >
          {t('dataCards.aiLooseAnalysis.description')}
        </Typography>
      </DataCard.Item>
      <DataCard.Item title={t('dataCards.aiLooseAnalysis.latestInspectionTitle')} colSpan={8}>
        {formatDate(sampleDate)}
      </DataCard.Item>
      <DataCard.Item colSpan={12}>
        <AiSampleBreakdown totalWeight={Number(totalWeight)} model={aiModel} composition={composition} />
      </DataCard.Item>
    </DataCard>
  );
};
